import React from 'react'
import { 
  DesktopMenuContainer, 
  MenuItemsContainer,
  MenuItemContainer,
  SubMenuContainer
} from '../containers/DesktopMenu'
import styled from '@emotion/styled'
import theme from '../styles/theme'
import { push as Menu } from 'react-burger-menu'
import { Link } from 'gatsby'

const MenuItems = [
  {
    uid: 'actualites',
    parent: null,
    name: 'Actualités',
    pathName: '/actualites/',
  },
  {
    uid: 'presse',
    parent: null,
    name: 'Presse',
    pathName: '/presse/',
  },
  {
    uid: 'projets',
    parent: null,
    name: 'Projets',
    pathName: '/projets/',
    children: [
      {
        uid: 'dreamland',
        parent: '/projets/',
        name: 'Dreamland',
      },
      {
        uid: 'l-etrange-histoire-du-petit-homme',
        parent: '/projets/',
        name: `L'étrange histoire`,
      },
      {
        uid: '60-secondes',
        parent: '/projets/',
        name: '60 secondes',
      }
    ]
  },
  {
    uid: 'realisations',
    special: 'clips',
    parent: null,
    name: 'Réalisations',
    pathName: '/realisations/',
    children: [
      {
        uid: 'clips',
        parent: '/realisations/',
        name: 'Clips',
      },
      {
        uid: 'fictions',
        parent: '/realisations/',
        name: `Fictions`,
      },
      {
        uid: 'documentaires',
        parent: '/realisations/',
        name: 'documentaires',
      }
    ]
  },
  {
    uid: 'photographies',
    parent: null,
    name: 'Photographies',
    pathName: '/photographies/',
  },
  {
    uid: 'les-z',
    parent: null,
    name: 'Les Z',
    pathName: '/les-z/',
  },
  {
    uid: 'a-propos',
    parent: null,
    name: 'À propos',
    pathName: '/a-propos/',
  },
];

const MobileMenuWrapper = styled(Menu)`
  > div {
    nav {
      ul {
        outline: none;
        margin: 0;
        li {
          list-style-type: none;
          a {
            font-family: ${props => props.theme.fontFamily};
            font-style: normal;
            text-transform: uppercase;
            text-decoration: none;
            font-weight: 400;
            padding: .5rem;
            display: block!important;
          }

          ul {
            margin: 0 0 0 15px;
            padding: 0;
            li {
              margin: 0;
              padding: 1px 0;
              a {
                padding: 0;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
`

const MobileMenuItem = styled(Link)`
  color: ${props => props.active}!important;
`;

var BurgerMenuStyles = {
  bmBurgerButton: {
    position: 'absolute',
    width: '36px',
    height: '30px',
    right: '25px',
    top: '24px',
    'zIndex': 2
  },
  bmBurgerBars: {
    background: '#373a47'
  },
  bmBurgerBarsHover: {
    background: '#a90000'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: '#bdc3c7'
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
    top: 0
  },
  bmMenu: {
    background: '#f2f2f2',
    padding: '0.5em 1.5em 0',
    fontSize: '1.15em'
  },
  bmMorphShape: {
    fill: '#373a47'
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em'
  },
  bmItem: {
    display: 'inline-block'
  },
  bmOverlay: {
    background: 'rgba(242, 242, 242, 0.7)',
    filter: 'blur(1.5rem)',
    top: 0
  }
}

export const DesktopMenu = (props) => {
  const { pathContext } = props;
  
  return (
    <React.Fragment>
      <DesktopMenuContainer itemScope itemType="http://www.schema.org/SiteNavigationElement">
        {
          MenuItems.map((item, index) => {
            return (
              <MenuItem 
                key={`menu-item-${index}`} 
                {...item} 
                context={pathContext}
                path={props.path}
              />
            )
          })
        }
      </DesktopMenuContainer>
    </React.Fragment>
  );
}

export const MobileMenu = (props) => {
  return (
    <MobileMenuWrapper right styles={BurgerMenuStyles}>
      <ul>
        <li>
          <MobileMenuItem to={`/actualites/`}>
            Actualités
          </MobileMenuItem>
        </li>

        <li>
          <MobileMenuItem to={`/presse/`}>
            Presse
          </MobileMenuItem>
        </li>

        <li>
          <MobileMenuItem to={`/presse/`}>
            Projets
          </MobileMenuItem>
          <ul>
            <li>
              <MobileMenuItem to={`/dreamland/`}>
                Dreamland
              </MobileMenuItem>
            </li>
            <li>
              <MobileMenuItem to={`/l-etrange-histoire-du-petit-homme/`}>
                L'étrange histoire
              </MobileMenuItem>
            </li>
            <li>
              <MobileMenuItem to={`/60-secondes/`}>
                60 secondes
              </MobileMenuItem>
            </li>
          </ul>
        </li>

        <li>
          <MobileMenuItem to={`/clips/`}>
            Réalisations
          </MobileMenuItem>
          <ul>
            <li>
              <MobileMenuItem to={`/clips/`}>
                Clips
              </MobileMenuItem>
            </li>
            <li>
              <MobileMenuItem to={`/fictions/`}>
                Fictions
              </MobileMenuItem>
            </li>
            <li>
              <MobileMenuItem to={`/documentaires/`}>
                Documentaires
              </MobileMenuItem>
            </li>
          </ul>
        </li>

        <li>
          <MobileMenuItem to={`/photographies/`}>
            Photographies
          </MobileMenuItem>
        </li>

        <li>
          <MobileMenuItem to={`/les-z/`}>
            Les Z
          </MobileMenuItem>
        </li>

        <li>
          <MobileMenuItem to={`/a-propos/`}>
            À propos
          </MobileMenuItem>
        </li>
      </ul>
    </MobileMenuWrapper>
  );
}

const MenuItem = (props) => {
  return (
    <MenuItemsContainer itemProp="name">
      <MenuItemContainer
        to={`/${props.special ? props.special : props.uid}/`}
        id={`nav-${props.uid}`}
        itemProp="url"
        active={(props.path === props.pathName || props.context.parent === props.uid) ? theme.colors.black : theme.colors.grey}
      >
        {props.name}
      </MenuItemContainer>
      { props.children && (
        <SubMenuContainer active={(props.context.parent === props.uid || props.path === props.pathName) ? 'flex' : 'none'}>
          { props.children.map((child, index) => {
            return (
              <li key={`submenu-item-${index}`}>
                <MenuItemContainer
                  to={`/${child.uid}/`}
                  id={`nav-${child.uid}`}
                  itemProp="url"
                  active={(child.uid === props.context.slug) ? theme.colors.black : theme.colors.light}
                >
                  {child.name}
                </MenuItemContainer>
              </li>
            )
          })}
        </SubMenuContainer>
      )}
    </MenuItemsContainer>
  );
}
